import { sortBy } from 'lodash';

export function tableReducer(state: any, action: any) {
    switch (action.type) {
        case 'CHANGE_SORT':
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.slice().reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }

            const sortedUpdate = sortBy(state.data, [action.column]);
            const sortedData = state.direction === 'descending' ? sortedUpdate.slice().reverse() : sortedUpdate;
            return {
                column: action.column,
                data: sortedData,
                direction: state.direction,
            };
        case 'UPDATE_DATA':
            const sorted = sortBy(action.data, [state.column]);
            const data = state.direction === 'descending' ? sorted.slice().reverse() : sorted;
            return { ...state, data };
        default:
            throw new Error();
    }
}

/**
 * given a color and a positive/negative percentage, returns the hex value of the
 * input color shaded "percent" lighter or darker. Useful for maintaining white label themes
 * without overloading the same color set (i.e. shading the background of an input slightly darker
 * than the background it sits on)
 * @param {string} color
 * @param {number} percent
 */
export const shadeColor = (color: string, percent: number) => {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(((R * (100 + percent)) / 100).toString());
    G = parseInt(((G * (100 + percent)) / 100).toString());
    B = parseInt(((B * (100 + percent)) / 100).toString());

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    const RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16);
    const GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16);
    const BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16);

    return '#' + RR + GG + BB;
};

export function addAlpha(color: string, opacity: number) {
    const _opacity = Math.round(Math.min(Math.max(opacity, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
}

export const dynamicTextColor = (hexcolor: string, black = 'black', white = 'white') => {
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
    }
    if (hexcolor.length === 3) {
        hexcolor = hexcolor
            .split('')
            .map(function (hex) {
                return hex + hex;
            })
            .join('');
    }
    const r = parseInt(hexcolor.substring(0, 2), 16);
    const g = parseInt(hexcolor.substring(2, 4), 16);
    const b = parseInt(hexcolor.substring(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 130 ? black : white;
};

const GRADE_COLOR = '#2f9ef2';

export const colorize = (v: number, valueArray: number[]) => {
    try {
        const numLess = valueArray.filter((value) => value < v).length;
        const percentile = (numLess / valueArray.length) * 100;
        if (percentile === 0) return '#FFFFFF';
        return addAlpha(GRADE_COLOR, 0.01 * percentile);
    } catch {
        return '#FFFFFF';
    }
};
